<template>
  <div class="core_wrap">
    <div class="core_title">
      <div>组建方式</div>
      <div class="en-font">Establishment Model</div>
    </div>
    <el-row class="core_options" type="flex" justify="space-around">
      <el-col
        class="core_items hidden-xs-only"
        v-for="(item, index) in coresList"
        :key="index"
        :class="item.isActive ? 'is_active' : ''"
        @click.native="changeCurrentIndex(index)"
        ><p>{{ item.tit }}</p>
        <p class="en">{{ item.en }}</p></el-col
      >
      <el-col
        class="core_items2 hidden-sm-and-up"
        v-for="(item, index) in coresList"
        :key="item.tit"
        :class="item.isActive ? 'is_active' : ''"
        @click.native="changeCurrentIndex(index)"
        >{{ item.tit }}</el-col
      >
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      coresList: [
        {
          tit: "公司+联盟",
          isActive: true,
          en: '"Enterprise + Alliance" model',
        },
        {
          tit: "浙江清华长三角研究院",
          isActive: true,
          en: "Zhejiang Tsinghua Yangtze River Delta Institute",
        },
      ],
      currentIndex: 0,
    };
  },
  methods: {
    changeCurrentIndex(index) {
      if (index === 0) {
        this.$router.push("/combination/1");
      } else {
        this.$router.push("/combination/2");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.core_wrap {
  width: 100%;
  padding: 50px;
  text-align: center;
  background: #e8eef2;
  @media screen and (max-width: 768px) {
    padding-bottom: 30px;
  }
  .core_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;
    .en-font {
      font-size: 20px;
    }
    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
      .en-font {
        font-size: 0.6rem;
      }
    }
  }
  .core_options {
    width: 70%;
    margin: 0 auto;
    @media screen and (max-width: 768px) {
      width: 90%;
    }
    .core_items {
      width: 40%;
      height: 70px;
      border: solid 1px #04cac7;
      font-size: 30px;
      // line-height: 70px;
      user-select: none;
      cursor: pointer;
      margin-bottom: 40px;
      @media screen and (max-width: 768px) {
        width: 45%;
        height: 100%;
      }
      .en {
        font-size: 14px;
      }
    }
    .core_items2 {
      width: 30%;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: solid 1px #04cac7;
      padding: 5px;
      font-size: 0.9rem;
      @media screen and (max-width: 768px) {
        width: 45%;
        height: 100%;
      }
    }
    .is_active {
      color: #fff;
      font-weight: bold;
      background: linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
      box-shadow: 0 0.5rem 1.5rem 0 rgb(0 135 168 / 50%);
    }
  }
}
</style>